import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { getBaseQueryAuth } from 'helpers/rtkQueryHelpers'
import {
  IAppealsResponse,
  IAppealsRequest,
  LkmAppealDetailResponse,
  LkmAppealDetailRequest,
  LkmClaimManipulationResponse,
  OrderFormResponse,
  OrderFormRequest,
  LkmAppealsStatisticsResponse,
} from '../types'

// API для страницы lkm "/orders"
export const lkmAppealsApi = createApi({
  reducerPath: 'LkmAppeals',
  refetchOnMountOrArgChange: true,
  baseQuery: getBaseQueryAuth,
  tagTypes: ['LkmAppealsList', 'lkmAppealDetail'],
  endpoints: builder => ({
    // Получение списка заявок
    getAppealsList: builder.query<IAppealsResponse, IAppealsRequest>({
      query: ({ status, page }) => ({
        url: '/v1/fitter/claims',
        method: 'POST',
        body: { status, page },
      }),
      serializeQueryArgs: ({ queryArgs }) =>
        `getAppealsList-${queryArgs.status}`,

      // Сливаем данные из разных страниц
      merge: (currentCache, newData, { arg }) => {
        if (arg.page === 1) {
          // если первая страница — сбрасываем
          return Object.assign(currentCache, newData)
        }

        currentCache.result.claims.push(...newData.result.claims)
        currentCache.result.count = newData.result.count

        return currentCache
      },

      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.page !== previousArg?.page
      },
      providesTags: ['LkmAppealsList'],
    }),
    getLkmAppeal: builder.query<
      LkmAppealDetailResponse,
      LkmAppealDetailRequest
    >({
      query: ({ claimId }) => ({
        url: `/v1/fitter/claims/${claimId}`,
        method: 'GET',
      }),

      providesTags: ['lkmAppealDetail'],
    }),
    claimAccept: builder.mutation<
      LkmClaimManipulationResponse,
      LkmAppealDetailRequest
    >({
      query: ({ claimId }) => ({
        url: `/v1/fitter/claim-accept`,
        method: 'POST',
        body: {
          claimId,
        },
      }),
      invalidatesTags: ['lkmAppealDetail'],
    }),
    claimRefuse: builder.mutation<
      LkmClaimManipulationResponse,
      LkmAppealDetailRequest
    >({
      query: ({ claimId }) => ({
        url: `/v1/fitter/claim-refuse`,
        method: 'POST',
        body: {
          claimId,
        },
      }),
    }),
    submitOrderForm: builder.mutation<OrderFormResponse, OrderFormRequest>({
      query: body => ({
        url: '/v1/fitter/claim-response',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['LkmAppealsList', 'lkmAppealDetail'],
    }),
    getLkmAppealStatistics: builder.query<LkmAppealsStatisticsResponse, void>({
      query: () => ({
        url: `/v1/fitter/completed-claims-statistics`,
        method: 'GET',
      }),
      transformResponse: (res: { result: LkmAppealsStatisticsResponse }) => {
        return res.result
      },
    }),
  }),
})

export const {
  useGetAppealsListQuery,
  useGetLkmAppealQuery,
  useClaimAcceptMutation,
  useClaimRefuseMutation,
  useSubmitOrderFormMutation,
  useGetLkmAppealStatisticsQuery,
} = lkmAppealsApi
